// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_m8Q","cls2":"SimplePaperPodcast-cls2__Xr SimplePaperPodcast-cls1_m8Q"};